<template>
	<p-panel-properties>
		<p-property-tile class="mb-4" icon="mdi-format-color-fill" title="Background color">
			<preset-input-color v-model="sideProperties.backgroundColor"></preset-input-color>
		</p-property-tile>

		<p-property-tile title="Border"></p-property-tile>
		<!-- Border width -->
		<p-property-tile icon="mdi-border-all-variant" title="Width">
			<p-panel-input-number
				class="lp-layout-style-select-input"
				v-model="sideProperties.border.widthInPx"
				:min="0"
				:max="100"
			/>
		</p-property-tile>

		<!-- Border styles -->
		<p-property-tile icon="mdi-border-top-variant" title="Style">
			<v-select
				:items="availableBorderStyle"
				v-model="sideProperties.border.style"
				item-text="text"
				class="lp-layout-style-select"
			></v-select>
		</p-property-tile>

		<!-- Border color -->
		<p-property-tile class="mb-4" icon="mdi-select-color" title="Color">
			<preset-input-color v-model="sideProperties.border.color"></preset-input-color>
		</p-property-tile>

		<!-- Icon selector -->
		<p-property-tile title="Icon">
			<icon-selector :selectedIcon="sideProperties.icon.name" @icon-selected="sideProperties.icon.name = $event">
				<template v-slot:activator="{ open }">
					<p-panel-button text="Select icon" tooltip="Select icon" @click="open" />
				</template>
			</icon-selector>
		</p-property-tile>
		
		<!-- Icon visibility -->
		<p-property-tile icon="mdi-eye" title="Visibility">
			<v-switch style="justify-content: flex-end;" v-model="sideProperties.icon.visible" hide-details />
		</p-property-tile>

		<!-- Icon color -->
		<p-property-tile icon="mdi-select-color" title="Color">
			<preset-input-color v-model="sideProperties.icon.color"></preset-input-color>
		</p-property-tile>

		<!-- Icon position -->
		<p-property-tile icon="mdi-format-align-center" title="Position">
			<v-select
				:items="availableIconPositions"
				v-model="sideProperties.icon.position"
				item-text="text"
				class="lp-layout-style-select"
			></v-select>
		</p-property-tile>

		<!-- Icon size -->
		<p-property-tile icon="transform" title="Size">
			<p-panel-input-number
				class="lp-layout-style-select-input"
				v-model="sideProperties.icon.sizeInPx"
				:min="0"
			/>
		</p-property-tile>
		
		<!-- Icon padding -->
		<p-property-tile icon="mdi-arrow-all" title="Padding">
			<p-panel-input-number
				class="lp-layout-style-select-input"
				v-model="sideProperties.icon.paddingInPx"
				:min="0"
			/>
		</p-property-tile>
	</p-panel-properties>
</template>

<script>
import PresetInputColor from '../../components/slides/styles/PresetInputColor.vue';
import PPanelPropertiesGroup from '../_components/utils/PPanelPropertiesGroup.vue';
import PPanelProperties from '../_components/utils/PPanelProperties.vue';
import PPropertyTile from '../_components/utils/PPropertyTile.vue';
import PPanelInputNumber from '../_components/utils/PPanelInputNumber.vue';
import PPanelButton from '../_components/utils/PPanelButton.vue';
import { IconPosition } from './class.js';
import IconSelector from '../../components/icon-selection/IconSelector.vue';

export default {
	props: ['sideProperties'],
	components: {
		PresetInputColor,
		PPanelPropertiesGroup,
		PPanelProperties,
		PPropertyTile,
		PPanelInputNumber,
		PPanelButton,
		IconSelector
	},
	data() {
		return {
			IconPosition
		};
	},
	computed: {
		availableBorderStyle() {
			const borderStyle = ['solid', 'dotted', 'dashed', 'double', 'groove', 'ridge', 'inset', 'outset'];
			return borderStyle.map(border => {
				return { text: `${border}`, value: border };
			});
		},
		availableIconPositions() {
			return [
				{ text: IconPosition.left, value: IconPosition.left },
				{ text: IconPosition.right, value: IconPosition.right }
			];
		}
	},
	methods: {
	}
};
</script>
